module.exports = __webpack_public_path__ + "images/emoji/strawberry.2a0294d86348bcacae1e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/strawberry.png
// module id = pucv
// module chunks = 1